/* codex-mens-collection-refresh */
(() => {
  if (window.location.pathname !== '/collections/mens-silicone-rings') return;

  const normalizeHero = () => {
    const hero = document.querySelector('.norelva-mens-hero');
    if (!hero) return;
    hero.style.setProperty('background', '#f4eee6', 'important');
    hero.style.setProperty('background-image', 'none', 'important');
  };

  const replaceBanner = async () => {
    const currentBanner = document.querySelector('[id^="shopify-section-template--"][id$="__banner"], [id^="shopify-section-template--"][id$="__norelva-mens-hero"]');
    const hero = document.querySelector('.norelva-mens-hero');
    const hasOldRecommendation = document.body.textContent.includes('Best for Everyday') || document.body.textContent.includes('Best Wedding Band Alternative');
    if (hero && !hasOldRecommendation) {
      normalizeHero();
      return;
    }
    if (!currentBanner) return;

    const sectionId = currentBanner.id.replace('shopify-section-', '');
    try {
      const response = await fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;

      const sections = await response.json();
      const html = sections[sectionId];
      if (!html || !html.includes('norelva-mens-hero')) return;

      const wrapper = document.createElement('div');
      wrapper.innerHTML = html.trim();
      const nextBanner = wrapper.firstElementChild;
      if (nextBanner) {
        currentBanner.replaceWith(nextBanner);
        normalizeHero();
      }
    } catch (error) {
      console.warn('Norelva mens collection refresh skipped', error);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceBanner, { once: true });
  } else {
    replaceBanner();
  }

  window.addEventListener('pageshow', normalizeHero);
})();
